import {AuthModel} from './_models'
import {staffCan} from './staffAccess'

type MonitorAccess = Partial<Pick<AuthModel, 'rl' | 'staff' | 'support'>>

// «پایش اتصال‌ها» shows every customer's server, database and log, so it is limited to staff granted
// «اتصال‌های حسابداری» in the CRM — the same rule the backend applies in AccountingSyncAdminController. A
// support session never sees other companies.
export const canMonitorAccountingSync = (user?: MonitorAccess | null): boolean =>
  !user?.support && staffCan(user, 'accountingSync')
